module.exports = __webpack_public_path__ + "2b1af01227e3c837a695a286bddff801.pdf";